/* eslint-disable no-nested-ternary */
import { useState } from "react";
import styles from "./ErrorPage.module.css";
import logo from "../../assets/cosmo-logo-white.svg";
import ErrorView from "./components/ErrorView";
import EmailMismatchView from "./components/EmailMismatchView";
import CustomerSupportOverlay from "./components/CustomerSupportOverlay";
import ActivationPendingView from "./components/ActivationPendingView";
import { ErrorViewButtonConfig } from "../../types/types";

interface Props {
  message?: string | undefined;
  title?: string | undefined;
  email?: string | undefined;
  buttonConfig?: ErrorViewButtonConfig;
  onEmailMismatchUpdate?: () => void;
}
// If Error Page is called from router, all values will be default values
const ErrorPage = ({
  message = "Unkown Error",
  email = undefined,
  title = "Oh no, something went wrong.",
  buttonConfig = { showButton: true, text: "Try Again", href: "/" },
  onEmailMismatchUpdate: emailMismatchUpdateHandler = () => {},
}: Props) => {
  const [showOverlay, setShowOverlay] = useState(false);

  const contactCustomerSupportHandler = () => setShowOverlay(true);

  const paperSx = {
    width: "80%",
    maxWidth: 500,
    borderRadius: 5,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    py: "2%",
  };

  return (
    <div className={styles.page}>
      <img src={logo} className={styles.logo} alt="cosmo logo" />
      {message === "email-mismatch" ? (
        <EmailMismatchView
          onContactCustomerSupport={contactCustomerSupportHandler}
          onEmailMismatchUpdate={emailMismatchUpdateHandler}
          paperSx={paperSx}
          newEmail={email!}
        />
      ) : message?.includes("Activation Pending") ? (
        <ActivationPendingView
          onContactCustomerSupport={contactCustomerSupportHandler}
          message={message}
          paperSx={paperSx}
          email={email!}
        />
      ) : (
        <ErrorView
          message={message}
          paperSx={paperSx}
          onContactCustomerSupport={contactCustomerSupportHandler}
          buttonConfig={buttonConfig}
          title={title}
        />
      )}
      <CustomerSupportOverlay
        onClose={() => setShowOverlay(false)}
        open={showOverlay}
        paperSx={paperSx}
      />
    </div>
  );
};
export default ErrorPage;
